// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --main-color: var(--color-brand-500, #422afb);
  --ligh-color: var(--color-brand-300, #80d9fb);
}

body {
  font-family: "Poppins", sans-serif;
}

option {
  color: black;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.wizardBody {
  overflow-y: auto;
  height: 83%;
  padding: 10px;
}

.wizardBody::-webkit-scrollbar {
  display: none;
}

.wizardBody::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

.wizardBody::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}

.wizard {
  overflow-y: auto;
  height: 88%;
  padding: 10px;
}

.wizard::-webkit-scrollbar {
  width: 8px;
}

.wizard::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

.wizard::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: var(--color-scrollbar-thumb, var(--color-brand-500, #422afb));
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/App.css"],"names":[],"mappings":"AAEA;EACE,6CAA6C;EAC7C,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+EAA+E;EAC/E,oDAAoD;AACtD","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n:root {\n  --main-color: var(--color-brand-500, #422afb);\n  --ligh-color: var(--color-brand-300, #80d9fb);\n}\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n}\n\noption {\n  color: black;\n}\n\n.no-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.wizardBody {\n  overflow-y: auto;\n  height: 83%;\n  padding: 10px;\n}\n\n.wizardBody::-webkit-scrollbar {\n  display: none;\n}\n\n.wizardBody::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n}\n\n.wizardBody::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);\n}\n\n.wizard {\n  overflow-y: auto;\n  height: 88%;\n  padding: 10px;\n}\n\n.wizard::-webkit-scrollbar {\n  width: 8px;\n}\n\n.wizard::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n}\n\n.wizard::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  background-color: var(--color-scrollbar-thumb, var(--color-brand-500, #422afb));\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
